import React, { useContext, useEffect, useRef, useState } from 'react'
import moment from 'moment';

import { useNavigate, useSearchParams } from 'react-router-dom';
import styles from "../../../Styles/ComponentStyles/MainPages/Member.module.scss"
import globalStyles from "../../../Styles/global.module.scss"

import Grid from '@mui/material/Grid2';
import { Avatar, CircularProgress, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import editIcon from "../../../Assets/Member/Edit-Icon.svg"
import deleteIcon from "../../../Assets/Member/Delete-Icons.svg"

import GlobalTextfield from '../../../Utils/Layout/GlobalTextfield/GlobalTextfield';
import GlobalSelect from '../../../Utils/Layout/GlobalSelect/GlobalSelect';
import GlobalButton from '../../../Utils/Layout/GlobalButton/GlobalButton';
import useStateOptions from '../../../Utils/Hooks/useStateOptions';

import { useIsBelow900 } from '../../../Utils/Constant/Constant';
import { useSnackbar } from '../../../Utils/Layout/GlobalSnackbar/GlobalSnackbar';

import { GroupNameResponseModel, UpdateMemberDetailsPayload } from '../../../models/memberAxiosModels';
import { MemberContext, MemberContextPayload } from '../../../Context/MemberDetailsContext';
import { GlobalUserContext, GlobalUserContextPayload } from '../../../Context/GlobalUserDetailContext';

import agent from '../../../Services/api';
import GlobalTabs from '../../../Utils/Layout/GlobalTabs/GlobalTabs';

const ViewUsers = () => {

    const navigate = useNavigate()
    const isBelow900 = useIsBelow900();
    const { showSnackbar } = useSnackbar();
    const { stateOptions, getStateOptions } = useStateOptions();

    const {
        memberUserListDetails,
        setMemberUserListDetails,
        storedExistingMemberDetails,
        setStoredExistingMemberDetails,
        userCredentialListDetails,
        setUserCredentialListDetails
    } = useContext(MemberContext) as MemberContextPayload

    const {
        flagLoader,
        setFlagLoader,
    } = useContext(GlobalUserContext) as GlobalUserContextPayload

    const [searchParams, setSearchParams] = useSearchParams();
    const userId = parseInt(searchParams.get('userId') || '', 10);
    const tabFromURL = searchParams.get("tab") || "1";
    const userTabs = [
        { label: 'Profile', value: '1' },
        { label: 'Integration', value: '2' },
    ];

    const imageInputRef = useRef<HTMLInputElement>(null);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [userStatusList, setUserStatusList] = useState<GroupNameResponseModel | null>(null)
    const [uploadFileId, setUploadFileId] = useState<number | null>(null)
    const [isUploading, setIsUploading] = useState<boolean>(false);
    const [currentTab, setCurrentTab] = useState(tabFromURL);
    const [isCredentialEditable, setIsCredentialEditable] = useState(false);
    // const [userGroupList, setUserGroupList] = useState<AppStatusResponse | null>(null)

    const initializeCredentialAuth = async () => {
        let payload = {
            userId: Number(userId)
        }
        setFlagLoader(true);
        const response = await agent.getUsersCredentialsApi.get(payload);

        if (response?.status && response?.data) {
            const userResponse = response.data?.credentials[0]
            setUserCredentialListDetails(userResponse);
            setFlagLoader(false);
        }
        else {
            setFlagLoader(false);
            const errorMessage = response?.data?.error?.message || 'Something Went Wrong!';
            showSnackbar(errorMessage, 'error');
        }
    };

    useEffect(() => {
        const tabFromURL = searchParams.get("tab") || "1";
        setCurrentTab(tabFromURL);
    }, [searchParams]);

    useEffect(() => {
        if (userId) {
            const fetchUserData = async () => {
                const payload = {
                    searchString: null,
                    userId: String(userId)
                }

                const response = await agent.getUsersByParamsApi.get(payload);
                if (response?.status && response?.data) {
                    console.log("response of getUsersByParamsApi", response);
                    const responseData = response?.data?.users[0]
                    setStoredExistingMemberDetails(responseData)

                }
                else {
                    // handle non-successful response
                }

            };

            fetchUserData();
        }
    }, [userId]);

    useEffect(() => {
        const fetchGroups = async () => {
            const response = await agent.getUsersStatusApi.get();
            if (response?.status && response?.data && response?.data?.userStatus) {
                setUserStatusList(response?.data)
            }
            else {
                setUserStatusList(null)
                const successMessage = response?.message ? response?.message : "Something Went Wrong!"
                showSnackbar(successMessage, "error");
                setFlagLoader(false)
            }
        };

        fetchGroups();
    }, [])

    useEffect(() => {
        getStateOptions()
    }, [])

    useEffect(() => {
        if (userId) {
            initializeCredentialAuth()
        }
    }, [])

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        setCurrentTab(newValue);
        setSearchParams(prev => {
            const params = new URLSearchParams(prev);
            params.set('tab', newValue);
            return params;
        });
    };

    const handleUpdateProfileDetails = async () => {

        if (!storedExistingMemberDetails?.firstName || !storedExistingMemberDetails?.lastName) {
            return
        }

        const payload: UpdateMemberDetailsPayload = {
            userId: storedExistingMemberDetails?.userId ?? 0,
            firstName: storedExistingMemberDetails?.firstName ?? "",
            lastName: storedExistingMemberDetails?.lastName ?? "",
            status: storedExistingMemberDetails?.userStatus?.status ?? "",
            contact: storedExistingMemberDetails?.contact ?? "",
            agencyName: storedExistingMemberDetails?.agencyName ?? "",
            city: storedExistingMemberDetails?.city ?? "",
            zipcode: storedExistingMemberDetails?.zipcode ?? "",
            stateID: storedExistingMemberDetails?.stateID ?? 0,
            addressLine1: storedExistingMemberDetails?.addressLine1 ?? "",
            addressLine2: storedExistingMemberDetails?.addressLine2 ?? "",
            affiliated_Brooklight: storedExistingMemberDetails?.affiliated_Brooklight ?? false,
            affiliated_BA: storedExistingMemberDetails?.affiliated_BA ?? false,
            profileImage: uploadFileId ?? 0
        };

        setFlagLoader(true)
        const response = await agent.updateUserStatusApi.put(payload)
        if (response?.status) {
            console.log("response of updateUserStatusApi", response);
            const successMessage = response?.message ? response?.message : "User details updated successfully!"
            showSnackbar(successMessage, "success");
            setFlagLoader(false)
        }
        else {
            console.log("response false of updateUserStatusApi", response);
            const successMessage = response?.error?.message ? response?.error?.message : "Something Went Wrong!"
            showSnackbar(successMessage, "error");
            setFlagLoader(false)
        }
    }

    const handleProfileMenuClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (imageInputRef.current) {
            imageInputRef.current.click(); // ← triggers file picker
        }
    };

    const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        setIsUploading(true);
        const formData = new FormData();
        formData.append("file", file);

        const response = await agent.uploadResourceFileAPI.post(formData)
        if (response?.status) {
            console.log("uploadResourceFileAPI response", response);
            const responseData = response?.data
            setIsUploading(false);
            setUploadFileId(responseData.google_storage_id)
            setStoredExistingMemberDetails({
                ...storedExistingMemberDetails,
                profileImage: responseData.google_storage_public_url
            })
        }
        else {
            console.error("Upload failed:", response);
            setIsUploading(false);
        }

        e.target.value = ""
    }

    const handleInputChange = (key: keyof typeof storedExistingMemberDetails, value: any) => {
        setStoredExistingMemberDetails((prev: any) => ({
            ...prev,
            [key]: value
        }));
    };

    const handleCredentialChange = (key: string, value: string) => {
        setUserCredentialListDetails((prev: any) => ({
            ...prev,
            [key]: value
        }));
    };

    const handleUpdateCredentials = async () => {

        const payload = {
            userId: storedExistingMemberDetails?.userId ?? 0,
            appName: userCredentialListDetails?.appName ?? "",
            username: userCredentialListDetails?.username ?? "",
            password: userCredentialListDetails?.password ?? ""
        }

        setFlagLoader(true)
        const response = await agent.changeUserCredentialsApi.post(payload)
        if (response?.status) {
            console.log("response of updateUserStatusApi", response);
            const successMessage = response?.message ? response?.message : "User credentials updated successfully!"
            showSnackbar(successMessage, "success");
            setFlagLoader(false)
        }
        else {
            console.log("response false of updateUserStatusApi", response);
            const successMessage = response?.error?.message ? response?.error?.message : "Something Went Wrong!"
            showSnackbar(successMessage, "error");
            setFlagLoader(false)
        }
    }


    return (
        <>
            <Grid container>
                <Grid size={{ xs: 12 }} className={`${styles.viewUserMainItem}`}>
                    <Grid container>
                        <Grid size={{ xs: 12 }} sx={{ marginBottom: "20px" }}>
                            <Grid container sx={{ justifyContent: "space-between" }}>
                                <Grid className={styles.userSaveCancelBtnItem}>
                                    <GlobalButton
                                        fullWidth={true}
                                        value='Back'
                                        variant='text'
                                        className={globalStyles.globalButtonTextStyleV1}
                                        size='medium'
                                        startIcon={<ArrowBackIcon sx={{ color: 'white' }} />}
                                        onClick={() => { navigate('/member') }}
                                    />
                                </Grid>
                                {/* <Grid className={styles.userSaveCancelBtnItem}>
                                    <GlobalButton
                                        fullWidth={true}
                                        value='Save'
                                        variant='contained'
                                        className={!storedExistingMemberDetails?.firstName || !storedExistingMemberDetails?.lastName ? globalStyles.globalButtonContainedStyleDisabledV1 : globalStyles.globalButtonContainedStyleV1}
                                        size='medium'
                                        onClick={() => { handleUpdateProfileDetails() }}
                                        disabled={!storedExistingMemberDetails?.firstName || !storedExistingMemberDetails?.lastName ? true : false}
                                    />
                                </Grid> */}
                            </Grid>
                        </Grid>

                        <Grid size={{ xs: 12 }}>
                            <Grid container className={styles.viewUserSaveCancelBtnItem}>
                                <Grid className={styles.memberUserProfileItem}>
                                    <Grid container className={styles.memberUserProfileContainer}>
                                        <Grid className={styles.memberProfileImageItem} sx={{ height: "100%" }}>
                                            <Avatar
                                                src={storedExistingMemberDetails?.profileImage || ""}
                                                sx={{ width: "100%", height: "100%" }}
                                            />
                                            {isUploading && (
                                                <div style={{ position: "absolute", zIndex: 2, top: "30px", left: "30px" }}>
                                                    <CircularProgress />
                                                </div>
                                            )}
                                            <div
                                                className={styles.memberProfileEditImageItem}
                                                onClick={handleProfileMenuClick}
                                            >
                                                <EditIcon
                                                    sx={{
                                                        background: '#0280FA',
                                                        color: 'white',
                                                        verticalAlign: "middle",
                                                        fontSize: '15px',
                                                        marginBottom: '2px',
                                                        borderRadius: "50%",
                                                        padding: "5px"
                                                    }}
                                                />
                                            </div>
                                            <input
                                                type="file"
                                                id="avatar"
                                                accept="image/*"
                                                ref={imageInputRef}
                                                style={{ display: "none" }}
                                                onChange={handleImageUpload}
                                            />
                                        </Grid>

                                        <Grid className={styles.memberProfileDetailsItem}>
                                            <Grid container>
                                                <Grid size={{ xs: 12 }}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV20}`}>
                                                        {storedExistingMemberDetails?.fullName ? storedExistingMemberDetails?.fullName : ""}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12 }}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`} sx={{ fontWeight: '300 !important' }}>
                                                        {storedExistingMemberDetails?.email ? storedExistingMemberDetails?.email : ""}
                                                    </Typography>
                                                </Grid>
                                                <Grid sx={{ maxWidth: '170px', marginTop: "10px" }}>
                                                    <Typography component={'span'} className={`${globalStyles.gblC7C7C7} ${globalStyles.globalTextV13}`}>
                                                        Created At: {storedExistingMemberDetails?.createdAt ? moment(storedExistingMemberDetails?.createdAt)?.format("MM/DD/YYYY") : ""}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid size={{ xs: 12 }} sx={{ margin: "25px 0px" }}>
                            <Grid container>

                                <Grid size={{ xs: 12 }} sx={{ margin: "0px 0px 15px" }}>
                                    <GlobalTabs
                                        tabs={userTabs}
                                        currentTab={currentTab}
                                        onChange={(event: React.SyntheticEvent, newValue: string) => handleTabChange(event, newValue)}
                                        sxTabStyle={{
                                            textTransform: 'none',
                                            color: '#7E7E7E',
                                            marginRight: '20px',
                                            fontWeight: 'normal',
                                            fontSize: '1rem',
                                            '&.Mui-selected': {
                                                color: '#ffffff',
                                                fontWeight: 'bold',
                                            }
                                        }}
                                    />
                                </Grid>

                                {currentTab == "1" &&
                                    <Grid size={{ xs: 12 }} sx={{ margin: "15px 0px 0px" }}>
                                        <Grid container sx={{ rowGap: "30px" }}>
                                            <Grid size={{ xs: 4 }} sx={{ maxWidth: "300px" }}>
                                                <Grid container>
                                                    <Grid size={{ xs: 12 }} sx={{ marginBottom: '10px' }}>
                                                        <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>User Status</Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12 }} >
                                                        <GlobalSelect
                                                            size='small'
                                                            fullWidth
                                                            className={`${globalStyles.gblDropdownStyles}`}
                                                            value={storedExistingMemberDetails?.userStatus?.id || ""}
                                                            options={
                                                                userStatusList?.userStatus?.length
                                                                    ? userStatusList.userStatus.map((status: any) => ({
                                                                        label: status.user_status_Desc,
                                                                        value: status.user_status_id
                                                                    }))
                                                                    : []
                                                            }
                                                            onChange={(e) => {
                                                                const selectedId = Number(e.target.value);
                                                                const matched = userStatusList?.userStatus.find(
                                                                    (status) => status.user_status_id === selectedId
                                                                );
                                                                if (matched) {
                                                                    handleInputChange("userStatus", {
                                                                        id: matched.user_status_id,
                                                                        status: matched.user_status_Desc
                                                                    });
                                                                }
                                                            }}
                                                        // onChange={(e) => handleInputChange("user_status_id", e.target.value)}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <Grid size={{ xs: 12 }}>
                                                <Grid container sx={{ columnGap: '40px', rowGap: '30px' }}>

                                                    <Grid className={`${styles.memberuserFieldItem}`}>
                                                        <Grid container className={`${styles.memberHeadFieldContainer}`}>
                                                            <Grid size={{ xs: 12 }}>
                                                                <Typography
                                                                    component={"span"}
                                                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}
                                                                >
                                                                    User Name
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }}>
                                                                <GlobalTextfield
                                                                    fullWidth={true}
                                                                    size='small'
                                                                    autoComplete='off'
                                                                    placeholder='Enter Username'
                                                                    value={storedExistingMemberDetails?.username ? storedExistingMemberDetails?.username : ""}
                                                                    onChange={(e) => handleInputChange("username", e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid className={`${styles.memberuserFieldItem}`}>
                                                        <Grid container className={`${styles.memberHeadFieldContainer}`}>
                                                            <Grid size={{ xs: 12 }}>
                                                                <Typography
                                                                    component={"span"}
                                                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}
                                                                >
                                                                    First Name
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }}>
                                                                <GlobalTextfield
                                                                    fullWidth
                                                                    size='small'
                                                                    placeholder='Enter First Name'
                                                                    autoComplete='off'
                                                                    value={storedExistingMemberDetails?.firstName ? storedExistingMemberDetails?.username : ""}
                                                                    onChange={(e) => handleInputChange("firstName", e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid className={`${styles.memberuserFieldItem}`}>
                                                        <Grid container className={`${styles.memberHeadFieldContainer}`}>
                                                            <Grid size={{ xs: 12 }}>
                                                                <Typography
                                                                    component={"span"}
                                                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}
                                                                >
                                                                    Last Name
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }}>
                                                                <GlobalTextfield
                                                                    fullWidth
                                                                    size='small'
                                                                    placeholder='Enter Last Name'
                                                                    autoComplete='off'
                                                                    value={storedExistingMemberDetails?.lastName ? storedExistingMemberDetails?.lastName : ""}
                                                                    onChange={(e) => handleInputChange("lastName", e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid className={`${styles.memberuserFieldItem}`}>
                                                        <Grid container className={`${styles.memberHeadFieldContainer}`}>
                                                            <Grid size={{ xs: 12 }}>
                                                                <Typography
                                                                    component={"span"}
                                                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}
                                                                >
                                                                    Agency Name
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }}>
                                                                <GlobalTextfield
                                                                    fullWidth
                                                                    size='small'
                                                                    placeholder='Enter Agency Name'
                                                                    autoComplete='off'
                                                                    value={storedExistingMemberDetails?.agencyName ? storedExistingMemberDetails?.agencyName : ""}
                                                                    onChange={(e) => handleInputChange("agencyName", e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid className={`${styles.memberuserFieldItem}`}>
                                                        <Grid container className={`${styles.memberHeadFieldContainer}`}>
                                                            <Grid size={{ xs: 12 }}>
                                                                <Typography
                                                                    component={"span"}
                                                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}
                                                                >
                                                                    Phone
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }}>
                                                                <GlobalTextfield
                                                                    fullWidth
                                                                    size='small'
                                                                    placeholder='Enter Phone Number'
                                                                    autoComplete='off'
                                                                    value={storedExistingMemberDetails?.contact ? storedExistingMemberDetails?.contact : ""}
                                                                    onChange={(e) => handleInputChange("contact", e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid className={`${styles.memberuserFieldItem}`}>
                                                        <Grid container className={`${styles.memberHeadFieldContainer}`}>
                                                            <Grid size={{ xs: 12 }}>
                                                                <Typography
                                                                    component={"span"}
                                                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}
                                                                >
                                                                    City
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }}>
                                                                <GlobalTextfield
                                                                    fullWidth
                                                                    size='small'
                                                                    placeholder='Enter City'
                                                                    autoComplete='off'
                                                                    value={storedExistingMemberDetails?.city ? storedExistingMemberDetails?.city : ""}
                                                                    onChange={(e) => handleInputChange("city", e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid className={`${styles.memberuserFieldItem}`}>
                                                        <Grid container className={`${styles.memberHeadFieldContainer}`}>
                                                            <Grid size={{ xs: 12 }}>
                                                                <Typography
                                                                    component={"span"}
                                                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}
                                                                >
                                                                    Zipcode
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }}>
                                                                <GlobalTextfield
                                                                    fullWidth
                                                                    size='small'
                                                                    placeholder='Enter Zip Code'
                                                                    autoComplete='off'
                                                                    value={storedExistingMemberDetails?.zipcode ? storedExistingMemberDetails?.zipcode : ""}
                                                                    onChange={(e) => handleInputChange("zipcode", e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid className={`${styles.memberuserFieldItem}`}>
                                                        <Grid container className={`${styles.memberHeadFieldContainer}`}>
                                                            <Grid size={{ xs: 12 }}>
                                                                <Typography
                                                                    component={"span"}
                                                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}
                                                                >
                                                                    State
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }} >
                                                                <GlobalSelect
                                                                    size='small'
                                                                    fullWidth
                                                                    className={`${globalStyles.gblDropdownStyles}`}
                                                                    options={
                                                                        stateOptions?.length ? stateOptions.map(state => ({
                                                                            label: `${state.state_name} (${state.state_abb})`,
                                                                            value: state.state_id
                                                                        })) : []
                                                                    }
                                                                    MenuProps={{ className: styles.userStateSelect }}
                                                                    onChange={(e) => handleInputChange("stateID", e.target.value)}
                                                                    value={storedExistingMemberDetails?.stateID || ""}
                                                                    renderValue={(selected) => {
                                                                        const selectedState = stateOptions.find(s => s.state_id == selected);
                                                                        return selectedState ? `${selectedState.state_name} (${selectedState.state_abb})` : '';
                                                                    }}

                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid className={`${styles.memberuserFieldItem}`}>
                                                        <Grid container className={`${styles.memberHeadFieldContainer}`}>
                                                            <Grid size={{ xs: 12 }}>
                                                                <Typography
                                                                    component={"span"}
                                                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}
                                                                >
                                                                    Address Line 1
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }} >
                                                                <GlobalTextfield
                                                                    fullWidth
                                                                    size='small'
                                                                    placeholder='Enter Address'
                                                                    autoComplete='off'
                                                                    multiline
                                                                    rows={3}
                                                                    stylingClassName={styles.memberProfileMultilineField}
                                                                    value={storedExistingMemberDetails?.addressLine1 ? storedExistingMemberDetails?.addressLine1 : ""}
                                                                    onChange={(e) => handleInputChange("addressLine1", e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid className={`${styles.memberuserFieldItem}`}>
                                                        <Grid container className={`${styles.memberHeadFieldContainer}`}>
                                                            <Grid size={{ xs: 12 }}>
                                                                <Typography
                                                                    component={"span"}
                                                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}
                                                                >
                                                                    Address Line 2
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }} >
                                                                <GlobalTextfield
                                                                    fullWidth
                                                                    size='small'
                                                                    placeholder='Enter Address'
                                                                    autoComplete='off'
                                                                    multiline
                                                                    rows={3}
                                                                    stylingClassName={styles.memberProfileMultilineField}
                                                                    value={storedExistingMemberDetails?.addressLine2 ? storedExistingMemberDetails?.addressLine2 : ""}
                                                                    onChange={(e) => handleInputChange("addressLine2", e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    {/* <Grid className={`${styles.memberuserFieldItem}`}>
                                    <Grid container sx={{ rowGap: { lg: "5px", md: "0px" } }}>
                                        <Grid size={12} className={`${globalStyles.gblFieldSpcaing}`}>
                                            <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                Affiliated with Broker Alliance
                                            </Typography>
                                        </Grid>
                                        <Grid size={12}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        size="small"
                                                        checked={true}
                                                        icon={<Icons iconName="checkbox" iconWidth="20px" iconHeight="20px" />}
                                                        checkedIcon={<Icons iconName="checkedIcon" iconWidth="20px" iconHeight="20px" />}
                                                        sx={{ padding: "0px 8px" }}
                                                    />
                                                }
                                                label=""
                                                className={styles.signinCheckboxLabel}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid className={`${styles.memberuserFieldItem}`}>
                                    <Grid container sx={{ rowGap: { lg: "5px", md: "0px" } }}>
                                        <Grid size={12} className={`${globalStyles.gblFieldSpcaing}`}>
                                            <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                Affiliated with Brooklight Place Securities
                                            </Typography>
                                        </Grid>
                                        <Grid size={12}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        size="small"
                                                        checked={true}
                                                        icon={<Icons iconName="checkbox" iconWidth="20px" iconHeight="20px" />}
                                                        checkedIcon={<Icons iconName="checkedIcon" iconWidth="20px" iconHeight="20px" />}
                                                        sx={{ padding: "0px 8px" }}
                                                    />
                                                }
                                                label=""
                                                className={styles.signinCheckboxLabel}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {currentTab == "2" &&
                                    <Grid size={{ xs: 12 }} sx={{ margin: "15px 0px 0px" }}>
                                        <Grid container>

                                            <TableContainer>
                                                <Table size='small'>
                                                    <TableHead className={`${globalStyles.gblTableHeadStyles}`}>
                                                        <TableRow>
                                                            <TableCell
                                                                className={`${globalStyles.gblTableHeadCell} ${globalStyles.gblTableMediumWidth}`}
                                                                sx={{ fontSize: "14px", borderTopLeftRadius: "5px" }}
                                                            >
                                                                APPS
                                                            </TableCell>
                                                            <TableCell
                                                                className={`${globalStyles.gblTableHeadCell} ${globalStyles.gblTableMediumWidth}`}
                                                                sx={{ fontSize: "14px" }}
                                                            >
                                                                USER NAME
                                                            </TableCell>
                                                            <TableCell
                                                                className={`${globalStyles.gblTableHeadCell} ${globalStyles.gblTableMediumWidth}`}
                                                                sx={{ fontSize: "14px", }}
                                                            >
                                                                USER PASSWORD
                                                            </TableCell>
                                                            <TableCell
                                                                className={`${globalStyles.gblTableHeadCell} ${globalStyles.gblTableExtraSmallWidth}`}
                                                                sx={{ fontSize: "14px", borderTopRightRadius: "5px" }}
                                                            >
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <TableRow className={`${globalStyles.gblTableBodyRow}`}>
                                                            <TableCell className={`${globalStyles.gblTableCellText}`}>
                                                                {userCredentialListDetails?.appName ? userCredentialListDetails?.appName : ""}
                                                            </TableCell>

                                                            <TableCell className={`${globalStyles.gblTableCellText}`}>
                                                                <GlobalTextfield
                                                                    size='small'
                                                                    stylingClassName={isCredentialEditable ? styles.credTextfield : styles.credTextfieldDisable}
                                                                    autoComplete='off'
                                                                    value={userCredentialListDetails?.username || ""}
                                                                    onChange={(e) => handleCredentialChange("username", e.target.value)}
                                                                    disabled={isCredentialEditable ? false : true}
                                                                />
                                                            </TableCell>

                                                            <TableCell className={`${globalStyles.gblTableCellText}`}>
                                                                <GlobalTextfield
                                                                    size='small'
                                                                    stylingClassName={isCredentialEditable ? styles.credTextfield : styles.credTextfieldDisable}
                                                                    autoComplete='off'
                                                                    value={userCredentialListDetails?.password || ""}
                                                                    onChange={(e) => handleCredentialChange("password", e.target.value)}
                                                                    disabled={isCredentialEditable ? false : true}
                                                                />
                                                            </TableCell>

                                                            <TableCell className={`${globalStyles.gblTableCellText}  ${globalStyles.gblTableExtraSmallWidth}`}>
                                                                <Grid container sx={{ justifyContent: "end", gap: "5px", alignItems: "center" }}>
                                                                    <IconButton sx={{ p: "2px" }} onClick={() => { setIsCredentialEditable(true) }}>
                                                                        <img src={editIcon} style={{ width: '30px', height: "30px" }} alt="edit" />
                                                                    </IconButton>
                                                                    <IconButton sx={{ p: "2px" }}>
                                                                        <img src={deleteIcon} style={{ width: '30px', height: "30px" }} alt="delete" />
                                                                    </IconButton>
                                                                </Grid>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>

                                        </Grid>
                                    </Grid>
                                }

                                <Grid size={{ xs: 12 }} sx={{ margin: "25px 0px 0px" }}>
                                    <Grid container sx={{ alignItems: 'center', gap: "20px" }}>
                                        <Grid className={styles.atUserProfileBtnItem}>
                                            <GlobalButton
                                                value='Cancel'
                                                size='medium'
                                                fullWidth={true}
                                                variant='outlined'
                                                className={globalStyles.globalButtonOutlinedStyleV1}
                                                onClick={() => { navigate('/member') }}
                                            />
                                        </Grid>
                                        <Grid className={styles.atUserProfileBtnItem}>
                                            {currentTab === "1" && (
                                                <GlobalButton
                                                    value='Save'
                                                    size='medium'
                                                    fullWidth
                                                    variant='contained'
                                                    className={globalStyles.globleButtonStyleV1}
                                                    disabled={!storedExistingMemberDetails?.firstName || !storedExistingMemberDetails?.lastName}
                                                    onClick={handleUpdateProfileDetails}
                                                />
                                            )}

                                            {currentTab === "2" && (
                                                <GlobalButton
                                                    value='Save'
                                                    size='medium'
                                                    fullWidth
                                                    variant='contained'
                                                    className={`${globalStyles.globleButtonStyleV1}`}
                                                    disabled={!userCredentialListDetails?.username || !userCredentialListDetails?.password}
                                                    onClick={handleUpdateCredentials}
                                                    sx={{ background: (!userCredentialListDetails?.username || !userCredentialListDetails?.password) ? "gray !important" : "white !important" }}
                                                />
                                            )}
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >
        </>
    )
}

export default ViewUsers